import Portfolio2GridContainer from "../../../../components/pages/portfolio/portfolioPage/Portfolio2Grid";

const Portfolio2Grid = () => {
  return <Portfolio2GridContainer />;
};

export default Portfolio2Grid;
